window.NaveeCounter = window.NaveeCounter || (function() {
  // 缓动函数: easeOutExpo
  const easeOutExpo = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

  const animate = (el, target, suffix, duration) => {
    let startTimestamp = null;
    const startValue = 0;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const ease = easeOutExpo(progress);
      
      const current = Math.floor(ease * (target - startValue) + startValue);
      el.innerText = current + suffix;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.innerText = target + suffix;
      }
    };
    window.requestAnimationFrame(step);
  };

  return {
    // 监听特定容器下的数字元素
    observe: function(containerSelector, itemSelector = '.stat-value') {
      const container = document.querySelector(containerSelector);
      if (!container) return;

      const items = container.querySelectorAll(itemSelector);
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;
            // 防止重复触发
            if (el.dataset.initialized === 'true') return;
            el.dataset.initialized = 'true';

            const target = parseInt(el.getAttribute('data-target')) || 0;
            const suffix = el.innerText.replace(/[0-9]/g, '');
            
            animate(el, target, suffix, 2000);
            observer.unobserve(el);
          }
        });
      }, { threshold: 0.2 });

      items.forEach(item => {
        if (item.dataset.initialized === 'true') return;
        // 初始化：提取单位并显示 0
        const suffix = item.innerText.replace(/[0-9]/g, '');
        item.innerText = "0" + suffix;
        observer.observe(item);
      });
    }
  };
})();

/**
 * 自动识别 data-animate-number 
 */
(function() {
  const animateNumbers = () => {
    const observerOptions = {
      threshold: 0.2 
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const el = entry.target;
        if (el.dataset.animateNumberStarted === 'true' || el.dataset.animateNumberDone === 'true') {
          observer.unobserve(el);
          return;
        }

        const rawTarget = el.getAttribute('data-target') || '';
        
        // 【核心修改】：检查是否为合法数字
        // parseFloat 会解析字符串，isNaN 检查是否解析失败
        // 我们还增加了一个正则校验，确保它是一个纯粹的数字格式
        const isNumeric = rawTarget !== '' && !isNaN(parseFloat(rawTarget)) && isFinite(rawTarget);

        if (!isNumeric) {
          // 如果是非数字，直接显示原始文字，不执行滚动逻辑
          const prefix = el.getAttribute('data-prefix') || '';
          const suffix = el.getAttribute('data-suffix') || '';
          el.innerHTML = prefix + rawTarget + suffix;
          el.dataset.animateNumberDone = 'true';
          observer.unobserve(el);
          return; 
        }

        // --- 以下为数字滚动逻辑 ---
        const decimals = rawTarget.includes('.') ? rawTarget.split('.')[1].length : 0;
        const target = parseFloat(rawTarget);
        const duration = parseInt(el.getAttribute('data-duration')) || 2000;
        const delay = parseInt(el.getAttribute('data-delay')) || 0; 
        const prefix = el.getAttribute('data-prefix') || '';
        const suffix = el.getAttribute('data-suffix') || '';

        if (entry.isIntersecting) {
          el.dataset.animateNumberStarted = 'true';
          clearTimeout(el._animateTimeout);
          cancelAnimationFrame(el._animateRafId);

          el._animateTimeout = setTimeout(() => {
            startCounter(el, target, duration, prefix, suffix, decimals);
          }, delay);
          observer.unobserve(el);
        } else {
          // 元素离开：仅对数字类型的元素进行重置
          clearTimeout(el._animateTimeout);
          cancelAnimationFrame(el._animateRafId);
          
          const zeroFormatted = (0).toLocaleString(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          });
          el.innerHTML = prefix + zeroFormatted + suffix;
        }
      });
    }, observerOptions);

    document.querySelectorAll('[data-animate-number]').forEach(el => {
      if (el.dataset.animateNumberStarted !== 'true' && el.dataset.animateNumberDone !== 'true') {
        observer.observe(el);
      }
    });
  };

  const startCounter = (el, target, duration, prefix, suffix, decimals) => {
    let startTimestamp = null;
    const startValue = 0;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      const currentValue = easeProgress * (target - startValue) + startValue;
      
      const formattedNumber = currentValue.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });

      el.innerHTML = prefix + formattedNumber + suffix;

      if (progress < 1) {
        el._animateRafId = window.requestAnimationFrame(step);
      } else {
        const finalNumber = target.toLocaleString(undefined, {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        });
        el.innerHTML = prefix + finalNumber + suffix;
        el.dataset.animateNumberDone = 'true';
      }
    };

    el._animateRafId = window.requestAnimationFrame(step);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', animateNumbers);
  } else {
    animateNumbers();
  }
})();
const formatMoney = (cents,formatString) => {
      let amount = (cents / 100).toFixed(2);
      // 简单处理分隔符
      amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formatString.replace(/\{\{\s*[\w\.]+\s*\}\}/, amount);
    };
const renderAccessoriesList = () => {
    const container = document.querySelector('[data-accessories]');
    const menuBasePriceContainer = document.querySelector('[data-menu-base-price]');
    const formatString = document.querySelector('[data-formatString]');
    if (container) {
      const fixedItems = [];
      const dynamicItems = (window.ACCESSORIES || []).map(item => item.title);
      const allItems = [...fixedItems, ...dynamicItems];
      const htmlContent = `<ul>${allItems.map(text => `<li>${text}</li>`).join('')}</ul>`;
      container.innerHTML = htmlContent;
    }
    if(menuBasePriceContainer){
      const basePrice = (window.ACCESSORIES || []).map(item => item.price);
      const totalPrice = basePrice.reduce((sum, price) => sum + price, 0);
      const sumPrice = totalPrice + parseFloat(menuBasePriceContainer.getAttribute('data-menu-base-price') || 0);
      const formatStringValue = formatString.getAttribute('data-formatString');
      console.log(formatStringValue)
      menuBasePriceContainer.innerText = `${formatMoney(sumPrice,formatStringValue)}`;
    }
};

(function(win) {
    const initialData = win.ACCESSORIES || [];
    let _internalArray;
    const arrayHandler = {
        set(target, property, value, receiver) {
            const success = Reflect.set(target, property, value, receiver);
            if (success && property !== 'length') {
                if (typeof renderAccessoriesList === 'function') {
                    renderAccessoriesList();
                }
            }
            return success;
        },
        deleteProperty(target, property) {
            const success = Reflect.deleteProperty(target, property);
            if (success && typeof renderAccessoriesList === 'function') {
                renderAccessoriesList();
            }
            return success;
        }
    };

    const createProxyArray = (arr) => {
        return new Proxy(Array.isArray(arr) ? arr : [], arrayHandler);
    };

    Object.defineProperty(win, 'ACCESSORIES', {
        get() {
            return _internalArray;
        },
        set(newValue) {
            _internalArray = createProxyArray(newValue);
            if (typeof renderAccessoriesList === 'function') {
                renderAccessoriesList();
            }
        },
        configurable: true,
        enumerable: true
    });

    win.ACCESSORIES = initialData;

})(window);
